module.exports = __webpack_public_path__ + "static/media/DigitalCardMockupGoogleFull-nz.24cbd13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/DigitalCardMockupGoogleFull-nz.png
// module id = 6161
// module chunks = 1